<template lang="pug">
.practice-status-buttons
  .practice-status-buttons__start
    .practice-status-buttons__label
      | 進捗状況
    ul.practice-status-buttons__items.is-button-group
      li.practice-status-buttons__item
        span.practice-status-buttons__button.a-button.is-sm.is-block.is-unstarted.js-not-complete(
          v-bind:disabled='statusName === "unstarted"',
          v-bind:class='[statusName === "unstarted" ? "is-active" : "is-inactive"]')
          | 未着手
      li.practice-status-buttons__item
        span.practice-status-buttons__button.a-button.is-sm.is-block.is-started.js-started(
          v-bind:disabled='statusName === "started"',
          v-bind:class='[statusName === "started" ? "is-active" : "is-inactive"]')
          | 着手
      //- li.practice-status-buttons__item(v-if='submission === "true"')
      //- 自学自習コースは提出物を作らず「提出中」を経由しないため表示しない
      li.practice-status-buttons__item(v-if='selfStudy !== "true"')
        span.practice-status-buttons__button.a-button.is-sm.is-block.is-submitted.js-submitted(
          v-bind:disabled='statusName === "submitted"',
          v-bind:class='[statusName === "submitted" ? "is-active" : "is-inactive"]')
          | 提出中
      li.practice-status-buttons__item
        span.practice-status-buttons__button.a-button.is-sm.is-block.is-complete.js-complete(
          v-bind:disabled='statusName === "complete"',
          v-bind:class='[statusName === "complete" ? "is-active" : "is-inactive"]')
          | 修了
  // NEXTRIBE: 全ての課題は提出物が必須な為
  //.practice-status-buttons__end(v-if='submission === "false"')
    .practice-status-buttons__note
      | この課題に提出物はありません。終了条件をクリアしたら修了にしてください。
</template>
<script>
import 'whatwg-fetch'
import CSRF from 'csrf'

export default {
  props: {
    practiceId: { type: String, required: true },
    status: { type: String, required: true },
    // submission: { type: String, required: true }
    // 自学自習コースかどうか（'true' / 'false' の文字列）
    selfStudy: { type: String, default: 'false' }
  },
  data() {
    return {
      statusName: null
    }
  },
  mounted() {
    this.statusName = this.status
  },
  methods: {
    pushStatus(name) {
      const params = new FormData()
      params.append('status', name)

      fetch(`/api/practices/${this.practiceId}/learning.json`, {
        method: 'PATCH',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': CSRF.getToken()
        },
        credentials: 'same-origin',
        redirect: 'manual',
        body: params
      })
        .then((response) => {
          if (response.ok) {
            this.statusName = name
            return this
          } else {
            response.json().then((data) => {
              alert(data.error)
            })
          }
        })
        .catch((error) => {
          console.warn(error)
        })
    }
  }
}
</script>
<style scoped></style>
